<template>
    <div>
        <notification class="info" icon-name="info-circle" icon-class="info-message">
            <p><strong>Mapping will only work for the fields that are available on the create screen in Jira.</strong></p>
        </notification>
        <div class="tfs4jira-mapping-layout">
            <div class="tfs4jira-mapping-layout-row">
                <div class="tfs4jira-mapping-layout-column-jira">
                    <h2>Jira Fields</h2>
                    <div class="tfs4jira-mapping-header-note-jira"></div>
                </div>
                <div class="tfs4jira-mapping-layout-column-tfs">
                    <h2>TFS Fields</h2>
                    <div class="tfs4jira-mapping-header-note-tfs"></div>
                </div>
            </div>
            <div class="tfs4jira-mapping-layout-row">
                <div class="tfs4jira-mapping-layout-column-jira">
                    <select id="jiraFieldsSelect" class="tfs4jira-mapping-select" size="10" v-model="selectedJiraValue">
                        <option v-for="value in jiraFields" :key=value.Key :value=value>
                            {{value.Value}}
                        </option>
                    </select>
                </div>
                <div class="tfs4jira-mapping-layout-column-tfs">
                    <select id="tfsFieldsSelect" class="tfs4jira-mapping-select" size="10" v-model="selectedTfsValue">
                        <option v-for="value in tfsFields" :key=value.Key :value=value>
                            {{value.Value}}
                        </option>
                    </select>
                </div>
            </div>        
        </div>
        <button  @click="addMapping()" 
                :disabled="disableMapButton()" 
                class="tfs4jira-mapping-map-button tfs4jira-rounded-button" 
                title="Please select values for both Jira and TFS to map them.">Map
        </button>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import { NAMESPACE as APP_NAMESPACE } from '../store/modules/app.js';
    import { NAMESPACE as FIELDS_MAPPING_NAMESPACE } from '../store/modules/fieldsMapping.js';
    import Notification from './Notification';

    export default {
        data() {
            return {
                 selectedTfsValue: null,
                 selectedJiraValue: null,
            }
        },
        computed: mapGetters({
            tfsFields: FIELDS_MAPPING_NAMESPACE.getters.TFS_VALUES,
            jiraFields: FIELDS_MAPPING_NAMESPACE.getters.JIRA_VALUES,
        }),
        methods: {
            ...mapActions({
                mapFields: FIELDS_MAPPING_NAMESPACE.actions.MAP,
                setJiraSelectedValue: FIELDS_MAPPING_NAMESPACE.actions.SET_SELECTED_JIRA_FIELD,
                setTfsSelectedValue: FIELDS_MAPPING_NAMESPACE.actions.SET_SELECTED_TFS_FIELD,
                registerListener: APP_NAMESPACE.actions.ADD_LISTENER
            }),            
            addMapping: function() {
                if (this.selectedJiraValue !== null && this.selectedTfsValue !== null) {
                    this.mapFields({
                        jiraField: this.selectedJiraValue, 
                        tfsField: this.selectedTfsValue
                    });
                    this.selectedTfsValue = null;
                    this.selectedJiraValue = null;
                }
            },
            disableMapButton: function() {
                return this.selectedJiraValue === null || this.selectedTfsValue === null;
            },
            documentClick: function(event) {
                let availableFieldsClicked = isAvailableFieldsClicked(event.target);
                if (!availableFieldsClicked) {
                    this.selectedTfsValue = null;
                    this.selectedJiraValue = null;
                }
            }            
        },
        created() {
            document.addEventListener('click', this.documentClick)
        },
        destroyed() {
            document.removeEventListener('click', this.documentClick)
        },
        watch: {
            selectedJiraValue: function(value) {
                this.setJiraSelectedValue(value);
            },
            selectedTfsValue: function(value) {
                this.setTfsSelectedValue(value);
            }
        },
        components: {
            Notification
        },
        mounted: function() {
            this.registerListener({
                on: 'MapEpicName',
                handler: function(notification) {
                    let EpicNameField = this.jiraFields.find(field => field.Value === 'Epic Name');
                    if(EpicNameField){
                        this.selectedJiraValue = EpicNameField;
                    }
                }.bind(this)
            });
        }
    }

    const isAvailableFieldsClicked = function(clickedElement) {
        let jiraSelect = document.getElementById("jiraFieldsSelect");
        let tfsSelect  = document.getElementById("tfsFieldsSelect");
        let parentElement = clickedElement.parentElement;
        if(clickedElement === jiraSelect || clickedElement === tfsSelect || parentElement === jiraSelect || parentElement === tfsSelect) {
            return true;
        }
        return false;
    };
</script>


// WEBPACK FOOTER //
// src/components/FieldsMappingSelects.vue